export const COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES = {
  notOpen: 'notOpen',
  update: 'update',
  success: 'success',
};
